import { render, staticRenderFns } from "./ZyroSettingsTitle.vue?vue&type=template&id=162b9177&scoped=true&"
import script from "./ZyroSettingsTitle.vue?vue&type=script&lang=js&"
export * from "./ZyroSettingsTitle.vue?vue&type=script&lang=js&"
import style0 from "./ZyroSettingsTitle.vue?vue&type=style&index=0&id=162b9177&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162b9177",
  null
  
)

export default component.exports